<template>
    <div id="app" style="width: 100%;height: 100%">
        <router-view></router-view>
    </div>
</template>
<script>
	export default {
		created() {
			sessionStorage.getItem("userMsg") && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(
				sessionStorage
				.getItem("userMsg"))));

			//在页面刷新时将vuex里的信息保存到sessionStorage里
			window.addEventListener("beforeunload", () => {
				sessionStorage.setItem("userMsg", JSON.stringify(this.$store.state))
			})
		}
	}
</script>
<style>
    @import "./assets/css/main.css";
    @import "./assets/css/color-dark.css";     /*深色主题*/
    /*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>